import privacy from "../assets/images/privacy_policy.png";
import terms from "../assets/images/terms_conditions.png";
import domain from "../assets/images/domain_name.png";
import invoice from "../assets/images/invoice.png";
import {ReactComponent as SearchIcon} from "../assets/images/search.svg";
import {ReactComponent as SelectIcon} from "../assets/images/select.svg";
import {ReactComponent as StandoutIcon} from "../assets/images/standout.svg";

export const products = [
  {
    image: privacy,
    title: "Privacy Policy Generator",
    details:
      "Stock your store with 100s of products and start selling to customers in minutes, without the hassle of inventory or packaging.",
  },

  {
    image: terms,
    title: "Terms & Conditions Generator",
    details:
      "Stock your store with 100s of products and start selling to customers in minutes, without the hassle of inventory or packaging.",
  },

  {
    image: domain,
    title: "Domain Name Generator",
    details:
      "Stock your store with 100s of products and start selling to customers in minutes, without the hassle of inventory or packaging.",
  },

  {
    image: invoice,
    title: "Invoice Generator",
    details:
      "Stock your store with 100s of products and start selling to customers in minutes, without the hassle of inventory or packaging.",
  },
];

export const feature = [
  {
    icon: SearchIcon,
    title: "Search",
    details:
      "Simply add a keyword or a term related to your business in the slogan maker search box. Wait for the magic to happen.",
  },
  {
    icon: SelectIcon,
    title: "Select",
    details: "Choose from thousands of options generated by the slogan maker that fit your needs.",
  },
  {
    icon: StandoutIcon,
    title: "Stand out",
    details: "Congrats on your new slogan. It's time to win the world!",
  },
];

export const sloganData = [
  "There is no Sore it will Not Heal, No cool it will not Subdue.",
  "coziness building for tomorrow",
  "There is no Sore it will Not Heal, No cool it will not Subdue.",
  "Review the facts cool is the best.",
  "There is no Sore it will Not Heal, No cool it will not Subdue.",
  "coziness building for tomorrow",
  "There is no Sore it will Not Heal, No cool it will not Subdue.",
  "Review the facts cool is the best.",
  "There is no Sore it will Not Heal, No cool it will not Subdue.",
  "coziness building for tomorrow",
  "There is no Sore it will Not Heal, No cool it will not Subdue.",
  "Review the facts cool is the best.",
  "There is no Sore it will Not Heal, No cool it will not Subdue.",
  "coziness building for tomorrow",
  "There is no Sore it will Not Heal, No cool it will not Subdue.",
  "Review the facts cool is the best.",
  "There is no Sore it will Not Heal, No cool it will not Subdue.",
  "Review the facts cool is the best.",
];